import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  makeStyles,
  LinearProgress
} from '@material-ui/core';

import { actions, CONSTANTS } from 'src/redux';
import Page from 'src/components/Page';
import EbookDetails from './EbookDetails';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const EbookCreateView = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { createEbook } = useSelector((state) => state.ebook);

  useEffect(() => {
    if (
      createEbook.status === CONSTANTS.STATUS.DONE
      && createEbook.type === 'EBOOK::CREATE_EBOOK'
    ) {
      dispatch(actions.ebook.createEbook.redirect());
      navigate('/app/ebooks');
    }
  }, [createEbook]);

  return (
    <Page className={classes.root} title="EbookCreateView">
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} xs={12}>
            {createEbook.status === CONSTANTS.STATUS.DONE || createEbook.status === null ? (
              <EbookDetails />
            ) : (
              <LinearProgress />
            )}
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default EbookCreateView;
